/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import Cookies from 'js-cookie'
import AxiosInterceptor from '../hooks/AxiosInterceptorHook';
import {apiURLs, getWithCredentials} from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return Promise.reject(new Error('CSRF token not found. Unable to send request.'))
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}



const createUserManagerAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: apiURLs.authenticateUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: getWithCredentials()
  });
  axiosInstance.interceptors.request.use(withCsrfHeader)
  const interceptor = AxiosInterceptor(axiosInstance)

  return {axiosInstance, interceptor}
}

const keepAliveAxios = createUserManagerAxiosInstance()

export default {
  keepAlive: () => {
    const url = '/keepalive'
    return keepAliveAxios.axiosInstance({
      url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })
  },
  setRequestInterceptor: (interceptor) => {
    keepAliveAxios.interceptor.setRequestInterceptor(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    keepAliveAxios.interceptor.setResponseInterceptor(interceptor)
  },
  setJwtToken: jwtToken => {
    keepAliveAxios.axiosInstance.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  },
};
